/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Remote_TitleInputs */

const tr_landing_community_tile_remote_title = /** @type {(inputs: Landing_Community_Tile_Remote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzak Masaüstü`)
};

const en_landing_community_tile_remote_title = /** @type {(inputs: Landing_Community_Tile_Remote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote Desktop`)
};

const de_landing_community_tile_remote_title = /** @type {(inputs: Landing_Community_Tile_Remote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote-Desktop`)
};

const ru_landing_community_tile_remote_title = /** @type {(inputs: Landing_Community_Tile_Remote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалённый рабочий стол`)
};

/**
* | output |
* | --- |
* | "Remote Desktop" |
*
* @param {Landing_Community_Tile_Remote_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_remote_title = /** @type {((inputs?: Landing_Community_Tile_Remote_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Remote_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_remote_title(inputs)
	if (locale === "de") return de_landing_community_tile_remote_title(inputs)
	if (locale === "ru") return ru_landing_community_tile_remote_title(inputs)
	return tr_landing_community_tile_remote_title(inputs)
});